module.exports = __webpack_public_path__ + "img/588x310-02.6b1569e8.png";